import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {setNotification} from "../../../notifications/notifications-actions";
import {Button} from "reactstrap";
import {handleApiResponse} from "../../../crud-actions";
import {push} from "connected-react-router";
import ContentShow from "../../content-editor/content-show";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class WelcomeAtWork extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            downloading: false
        }
    }

    markAsDone = (notify = true) => {
        const assignmentId = this.props.assignment.id;
        let promise = this.props.assignmentAction('api/v1', assignmentId, { execute: 'mark_as_done' });
        return handleApiResponse('ASSIGNMENT','ACTION', promise,
            (response) => {
                if (notify) {
                    this.props.push('/dashboard/');
                    this.props.setNotification('success', this.props.intl.formatMessage({id: "app.content_units.mark_as_done.success"}));
                }
            },
            (response) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            },
            (response) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            });
    };

    render() {
        const { assignment, readOnly } = this.props;
        let firstDay = assignment.employee_data.first_work_day;
        const contentUnit = assignment.content_unit;
        const information = assignment.actions[0] ? assignment.actions[0]['data']['information'] : null;

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                    <hr/>
                    { !information && <p><FormattedMessage id='app.first_work_day.not_yet_set'/></p> }
                    { information && <p style={{whiteSpace: 'pre'}}>{ information }</p>}
                    {
                        !readOnly && information && assignment.state !== 'complete' &&
                        <div>
                            <hr/>
                            <Button onClick={this.markAsDone}><FormattedMessage id='app.actions.mark_as_done'/></Button>
                        </div>
                    }
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        constants: state.constants
    };
}

export default injectIntl(connect(mapStateToProps)(WelcomeAtWork));
